import { addItemToCart } from './cart-service.js';

/**
 * Product Card Custom Element
 * Handles add to cart form submission for product cards
 */

class ProductCard extends HTMLElement {
  constructor() {
    super();
    this.forms = [];
    this.isSubmitting = false;

    // Bind methods
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  connectedCallback() {
    // A card can render more than one add-to-cart form (e.g. the desktop
    // hover button and the mobile icon button), so wire up all of them.
    this.forms = Array.from(this.querySelectorAll('form[action*="/cart/add"]'));
    this.forms.forEach((form) => form.addEventListener('submit', this.handleSubmit));
  }

  disconnectedCallback() {
    // Remove event listeners
    this.forms.forEach((form) => form.removeEventListener('submit', this.handleSubmit));
  }

  /**
   * Handle form submission
   * Prevents default form submission and uses AJAX to add to cart
   */
  async handleSubmit(event) {
    event.preventDefault();

    // Prevent multiple simultaneous submissions
    if (this.isSubmitting) return;

    const form = event.currentTarget;
    const variantInput = form.querySelector('input[name="id"]');
    const submitButton = form.querySelector('button[type="submit"]');
    if (!variantInput) return;

    const variantId = variantInput.value;
    if (!variantId) {
      console.error('No variant ID found');
      return;
    }

    // Get quantity from form (default to 1 if not present)
    const quantityInput = form.querySelector('input[name="quantity"]');
    const quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

    this.isSubmitting = true;

    // Disable button during submission
    const btnDisabledText = submitButton ? submitButton.querySelector('[disabled-text]') : null;
    const originalButtonText = btnDisabledText ? btnDisabledText.textContent : null;
    if (submitButton) submitButton.disabled = true;
    const loadingText = window.umbrellaConfig.addToCart.submit;
    if (btnDisabledText) {
      btnDisabledText.textContent = loadingText;
    }

    try {
      await addItemToCart(variantId, quantity, new FormData(form));
    } catch (error) {
      console.error('Error adding to cart:', error);
      alert(error.message || 'Failed to add item to cart. Please try again.');
    } finally {
      this.isSubmitting = false;

      // Restore button text and state
      if (submitButton) {
        if (btnDisabledText && originalButtonText) {
          btnDisabledText.textContent = originalButtonText;
        }
        submitButton.disabled = false;
      }
    }
  }
}

// Register the custom element
customElements.define('product-card', ProductCard);

